<template>
  <div class="interaction-body answered poll poll-answered">
    <div
        class="poll-option playposit-answer mb-1 pa-1"
        :class="{
          'ungraded': localInteractionAttempt.interactionOptionIds.includes(io.id),
        }"
        :key="io.id"
        v-for="(io, idx) in localInteraction.interactionOptions"
      >
        <v-checkbox
          class="mt-0"
          tabindex="0"
          v-model="localInteractionAttempt.interactionOptionIds"
          :value="io.id"
          :ripple="false"
          readonly
          hide-details
          :color="localInteractionAttempt.interactionOptionIds.includes(io.id) ? '#2196F3' : ''"
          :aria-label="`Answer #${idx + 1}. Answer status: ${localInteractionAttempt.interactionOptionIds.includes(io.id) ? 'Selected' : 'Unselected'}. Answer value: ${io.sanitizedOption}`"
        >
          <div
            slot="label"
            class="pp-interaction-body"
            v-html="io.option"
          ></div>
        </v-checkbox>
        <InteractionAttachments :attachments="io.interactionOptionAttachments" />
        <text-box
          v-show="io.feedback.length && localInteractionAttempt.interactionOptionIds.includes(io.id)"
          color-key="ungraded"
          title="Feedback"
          :text="io.feedback"
          tabindex="0"
          :aria-label="`Feedback for answer #${idx + 1}: ${io.feedback.length ? io.feedback.stripHTML(['img', 'Image']) : ''}`"
          :attachments="io.interactionOptionFeedbackAttachments"
          :add-extra-space-above="!io.interactionOptionAttachments.length"
        ></text-box>
      </div>
    </div>
</template>

<script>
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import TextBox from '../../Snippets/TextBox.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'MultiselectPollAnsweredInteractionBody',
  components: {
    InteractionAttachments,
    TextBox,
  },
  mixins: [
    Interaction,
  ],
  props: {
    interactionAttempt: {
      type: Object,
      required: true,
    },
  },
};
</script>
